import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { useLocale } from '@/hooks/useLocale';
import { toLocaleUrl } from '../utils/toLocaleUrl';

/**
 * Get the absolute route to the company report page.
 *
 * Supersedes directly accessing the `useCompanyCanonicalUrl` as a navigable link.
 */
export const useCompanyReportPageUrl = () => {
  const canonicalUrl = useCompanyCanonicalUrl();
  const locale = useLocale();
  return toLocaleUrl(locale, canonicalUrl);
};
